import LegalLayout from "./LegalLayout";

export default function RefundPolicy() {
  return (
    <LegalLayout title="Politique de remboursement et de retour" updated="23 juillet 2026">
      <p>
        Chez <strong>Délices Mikaté Royal</strong>, nous accordons une grande importance à la
        satisfaction de nos clients et à la qualité de nos produits.
      </p>
      <p>
        Comme nos produits sont des aliments préparés artisanalement et destinés à la consommation,
        certaines conditions particulières s&apos;appliquent aux remboursements et aux retours.
      </p>

      <h2>1. Produits alimentaires</h2>
      <p>
        Pour des raisons d&apos;hygiène, de sécurité alimentaire et de fraîcheur, les produits
        alimentaires ne peuvent généralement pas être retournés une fois remis au client.
      </p>
      <p>Nous vous invitons à vérifier votre commande dès sa réception.</p>

      <h2>2. Produits endommagés ou erreur de commande</h2>
      <p>
        Si votre commande présente un problème (produit manquant, erreur dans la commande ou produit reçu
        dans un état inadéquat), veuillez communiquer avec nous dans les plus brefs délais après la
        réception.
      </p>
      <p>Nous pourrons vous demander&nbsp;:</p>
      <ul>
        <li>une description du problème&nbsp;;</li>
        <li>des photos du produit concerné&nbsp;;</li>
        <li>les informations relatives à votre commande.</li>
      </ul>
      <p>
        Après analyse de la situation, Délices Mikaté Royal pourra proposer une solution appropriée,
        telle qu&apos;un remplacement ou un remboursement partiel ou complet lorsque justifié.
      </p>

      <h2>3. Annulation d&apos;une commande</h2>
      <p>
        Les demandes d&apos;annulation doivent être faites le plus rapidement possible avant le début de
        la préparation de la commande.
      </p>
      <p>
        Une fois la préparation commencée, l&apos;annulation peut ne plus être possible en raison de la
        nature périssable des produits.
      </p>

      <h2>4. Commandes pour événements</h2>
      <p>Pour les commandes importantes, les événements ou les commandes personnalisées&nbsp;:</p>
      <ul>
        <li>les modalités d&apos;annulation peuvent être établies au moment de la confirmation&nbsp;;</li>
        <li>un délai de préavis peut être exigé&nbsp;;</li>
        <li>des frais peuvent s&apos;appliquer selon l&apos;état d&apos;avancement de la préparation.</li>
      </ul>
      <p>Ces conditions seront communiquées au client avant la confirmation finale.</p>

      <h2>5. Absence du client ou informations incorrectes</h2>
      <p>Le client est responsable de fournir des informations exactes concernant&nbsp;:</p>
      <ul>
        <li>l&apos;adresse de livraison&nbsp;;</li>
        <li>les coordonnées&nbsp;;</li>
        <li>l&apos;heure ou le lieu de récupération.</li>
      </ul>
      <p>
        Délices Mikaté Royal ne peut être tenu responsable des problèmes résultant d&apos;informations
        incorrectes fournies par le client.
      </p>

      <h2>6. Remboursements</h2>
      <p>
        Lorsqu&apos;un remboursement est approuvé, celui-ci sera effectué selon le même mode de paiement
        utilisé lors de la transaction, lorsque cela est possible.
      </p>
      <p>Le délai de traitement peut varier selon le fournisseur de paiement.</p>

      <h2>7. Satisfaction de la clientèle</h2>
      <p>
        Si vous avez une question ou une insatisfaction concernant votre commande, nous vous encourageons
        à communiquer avec nous afin que nous puissions trouver une solution appropriée.
      </p>

      <h2>8. Contact</h2>
      <p>
        <strong>Délices Mikaté Royal</strong><br />
        Site Web&nbsp;: <a href="https://www.mikateroyal.com" target="_blank" rel="noreferrer">www.mikateroyal.com</a><br />
        Courriel&nbsp;: <a href="mailto:contact@mikateroyal.com">contact@mikateroyal.com</a>
      </p>
    </LegalLayout>
  );
}
